export function getDefaults(_ref) {
  var {
    focusBorderColor = 'blue.275',
    errorBorderColor = 'red.850',
    focusBoxShadowColor = 'blue.300',
    errorBoxShadowColor = 'red.850',
    outlineFocusColor = 'blue.200'
  } = _ref;
  return {
    focusBorderColor,
    errorBorderColor,
    focusBoxShadowColor,
    errorBoxShadowColor,
    outlineFocusColor
  };
}